module.exports = __webpack_public_path__ + "static/media/memento_icon_pdf.cf87265e.png";